import React, { useState } from "react";
import { Input } from "../../Components/FormElements";
import { PrimaryButton } from "../../Components/Cta";
import { useNavigate } from "react-router-dom";
import { SuccessModal } from "../../Components/Modals";

export default function EditRiskScores() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  // ✅ Separate states for each input
  const [lowFrom, setLowFrom] = useState("");
  const [lowTo, setLowTo] = useState("");
  const [highFrom, setHighFrom] = useState("");
  const [highTo, setHighTo] = useState("");
  const [mediumFrom, setMediumFrom] = useState("");
  const [mediumTo, setMediumTo] = useState("");

  // (Optional) validation state if you want errors
  const [error, setError] = useState("");

  const _validateOptions = (e) => {
    // Example: prevent typing non-numeric in "To" inputs
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleSave = () => {
    // Example: validation before saving
    if (
      !lowFrom ||
      !lowTo ||
      !highFrom ||
      !highTo ||
      !mediumFrom ||
      !mediumTo
    ) {
      setError("All fields are required");
      return;
    }

    const payload = {
      lowRisk: { from: lowFrom, to: lowTo },
      highRisk: { from: highFrom, to: highTo },
      mediumRisk: { from: mediumFrom, to: mediumTo },
    };

    console.log("Saving risk scores:", payload);
    // 👉 call API or updateData(payload)
    setShowModal(true);
  };

  return (
    <div className="row px-3 pt-3">
      <div className="col-xl-4 col-lg-6 col-md-7 col-12">
        <div className="e-bg-floral-white p-3 e-border-radius-16 w-100">
          {/* LOW RISK */}
          <h5 className="e-font-16 e-primary-font-poppins e-font-weight-500 e-text-eerie-black">
            Low Risk Low Return
          </h5>
          <div className="d-flex flex-column row-gap-3 ">
            <div className="row">
              <div className="col-lg-8">
                <Input
                  type="text"
                  label="From"
                  labelStyle="e-font-14 e-font-weight-400 text-capitalize e-primary-font-poppins pb-2"
                  require={true}
                  value={lowFrom}
                  error={!lowFrom && error}
                  className="e-primary-font-poppins w-100"
                  handleChange={setLowFrom}
                />
              </div>
              <div className="col-lg-4">
                <Input
                  type="number"
                  label="To"
                  labelStyle="e-font-14 e-font-weight-400 e-primary-font-poppins pb-2"
                  require={true}
                  value={lowTo}
                  error={!lowTo && error}
                  className="e-primary-font-poppins w-100"
                  onKeyPress={_validateOptions}
                  handleChange={setLowTo}
                />
              </div>
            </div>
          </div>
          {/* MEDIUM RISK */}
          <h5 className="e-font-16 e-primary-font-poppins e-font-weight-500 e-text-eerie-black e-pt-32px">
            Medium Risk Medium Return
          </h5>
          <div className="d-flex flex-column row-gap-3 ">
            <div className="row">
              <div className="col-lg-8">
                <Input
                  type="text"
                  label="From"
                  labelStyle="e-font-14 e-font-weight-400 text-capitalize e-primary-font-poppins pb-2"
                  require={true}
                  value={mediumFrom}
                  error={!mediumFrom && error}
                  className="e-primary-font-poppins w-100"
                  handleChange={setMediumFrom}
                />
              </div>
              <div className="col-lg-4">
                <Input
                  type="number"
                  label="To"
                  labelStyle="e-font-14 e-font-weight-400 e-primary-font-poppins pb-2"
                  require={true}
                  value={mediumTo}
                  error={!mediumTo && error}
                  className="e-primary-font-poppins w-100"
                  onKeyPress={_validateOptions}
                  handleChange={setMediumTo}
                />
              </div>
            </div>
          </div>
          <h5 className="e-font-16 e-primary-font-poppins e-font-weight-500 e-text-eerie-black e-pt-32px">
            High Risk High Return
          </h5>
          <div className="d-flex flex-column row-gap-3 ">
            <div className="row">
              <div className="col-lg-8">
                <Input
                  type="text"
                  label="From"
                  labelStyle="e-font-14 e-font-weight-400 text-capitalize e-primary-font-poppins pb-2"
                  require={true}
                  value={highFrom}
                  error={!highFrom && error}
                  className="e-primary-font-poppins w-100"
                  handleChange={setHighFrom}
                />
              </div>
              <div className="col-lg-4">
                <Input
                  type="number"
                  label="To"
                  labelStyle="e-font-14 e-font-weight-400 e-primary-font-poppins pb-2"
                  require={true}
                  value={highTo}
                  error={!highTo && error}
                  className="e-primary-font-poppins w-100"
                  onKeyPress={_validateOptions}
                  handleChange={setHighTo}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="row mt-4">
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-border-1px-blue e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
              name="Cancel"
              onPress={() => navigate("/manage-general")}
            />
          </div>
          <div className="col-6">
            <PrimaryButton
              ClassName="e-border-radius-pill e-font-weight-500 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
              name="Save"
              onPress={handleSave}
            />
          </div>
        </div>
      </div>
      {showModal && (
        <SuccessModal
          title={"Successfull"}
          message={
            "Lorem ipsum dolor sit amet consectetur. Eu risus purus suspendisse leo pellentesque blandit id tellus."
          }
          onClick={() => {
            setShowModal(false);
            navigate("/manage-general");
          }}
          close={() => {
            setShowModal(false);
            navigate("/manage-general");
          }}
          buttonName={"Ok"}
        />
      )}
    </div>
  );
}
